export function formatMoney(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase()
    }).format(amount)
  } catch {
    return `${currency.toUpperCase()} ${amount.toFixed(2)}`
  }
}

/** due date minus issue date in whole days, the "net N" payment term. null when
 * either date is missing so the column can render a dash.
 */
export function netTermDays(
  issuedAt: string | null,
  dueAt: string | null
): number | null {
  if (!issuedAt || !dueAt) return null
  const issue = new Date(issuedAt)
  const due = new Date(dueAt)
  if (Number.isNaN(issue.getTime()) || Number.isNaN(due.getTime())) return null
  return Math.round((due.getTime() - issue.getTime()) / 86_400_000)
}
